import React, { useState, useEffect } from 'react';
import "./AdminPanel.css";
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import AdminSidebar from "./AdminSidebar";
import AdministratorSidebar from "./AdministratorSidebar";
import UserSidebar from "./UserSidebar";
import './Invoice.css'; // Import the CSS file containing overlay styles (adjust path if needed)

const EditVehiclesThirdParty = () => {
    const navigate = useNavigate();
    const [userType, setUserType] = useState("");
    const [userName, setUserName] = useState("");
    const [userFullName, setUserFullName] = useState("");
    const [isUpdating, setIsUpdating] = useState(false); // State to control overlay

    useEffect(() => {
        const storedUserType = localStorage.getItem("usertype");
        const storedUserName = localStorage.getItem("userName");
        const storedFName = localStorage.getItem("fname");
        const storedLName = localStorage.getItem("lname");

        console.log('User type from localStorage:', storedUserType);
        if (!storedUserType) {
            navigate("/login");
        } else {
            setUserType(storedUserType);
            setUserName(storedUserName);
            setUserFullName(storedFName && storedLName ? `${storedFName} ${storedLName}` : storedFName || storedUserName);
        }
    }, [navigate]);

    const logout = () => {
        localStorage.removeItem("token");
        localStorage.removeItem("email");
        localStorage.removeItem("userName");
        localStorage.removeItem("usertype");
        localStorage.removeItem("fname");
        localStorage.removeItem("lname");
        navigate("/login");
    };

    const { id } = useParams();
    const [car, setCar] = useState({});
    const [formData, setFormData] = useState({});
    const [newImageFile, setNewImageFile] = useState(null);
    const [newGalleryImages, setNewGalleryImages] = useState([]);
    const [galleryImages, setGalleryImages] = useState([]);
    const [features, setFeatures] = useState({});

    useEffect(() => {
        fetchCarDetails();
        fetchGalleryImages();
    }, [id]);

    const fetchCarDetails = async () => {
        try {
            const response = await axios.get(`https://api.mitradingjp.com/fetch_car_details_ThirdParty.php?id=${id}`);
            console.log('Fetched car details:', response.data[0]);
            setCar(response.data[0]);
            setFormData(response.data[0]);
            setFeatures(response.data[0].features ? JSON.parse(response.data[0].features) : {});
        } catch (error) {
            console.error('Error fetching car details:', error);
        }
    };

    const fetchGalleryImages = async () => {
        try {
            const response = await axios.get(`https://api.mitradingjp.com/fetch_car_images.php?id=${id}`);
            console.log('Fetched gallery images:', response.data);
            setGalleryImages(response.data);
        } catch (error) {
            console.error('Error fetching gallery images:', error);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleFeatureChange = (e) => {
        const { name, checked } = e.target;
        const updatedFeatures = { ...features, [name]: checked };
        setFeatures(updatedFeatures);
        setFormData({ ...formData, features: JSON.stringify(updatedFeatures) });
    };

    const handleMainImageChange = (e) => {
        setNewImageFile(e.target.files[0]);
    };

    const handleGalleryImagesChange = (e) => {
        setNewGalleryImages([...e.target.files]);
    };

    const handleUpdate = async () => {
        setIsUpdating(true); // Show overlay
        try {
            const dataToSend = { ...formData, id: id };
            console.log('Initial data to send:', dataToSend);

            if (newImageFile) {
                console.log('Uploading main image:', newImageFile.name);
                const formData = new FormData();
                formData.append('image', newImageFile);
                const uploadResponse = await axios.post('https://api.mitradingjp.com/upload_image.php', formData, {
                    headers: { 'Content-Type': 'multipart/form-data' },
                });
                console.log('Main image upload response:', uploadResponse.data);
                if (uploadResponse.data.imagePath) {
                    dataToSend.images = uploadResponse.data.imagePath;
                    console.log('Main image path set:', dataToSend.images);
                } else {
                    console.error('Main image upload failed:', uploadResponse.data);
                    throw new Error('Main image upload failed: ' + JSON.stringify(uploadResponse.data));
                }
            } else {
                console.log('No main image selected');
            }

            if (newGalleryImages.length > 0) {
                const uploadedGalleryImagePaths = [];
                console.log('Uploading', newGalleryImages.length, 'gallery images');
                for (const file of newGalleryImages) {
                    console.log('Uploading gallery image:', file.name);
                    const formData = new FormData();
                    formData.append('image', file);
                    const uploadResponse = await axios.post('https://api.mitradingjp.com/upload_image.php', formData, {
                        headers: { 'Content-Type': 'multipart/form-data' },
                    });
                    console.log('Gallery image upload response:', uploadResponse.data);
                    if (uploadResponse.data.imagePath) {
                        uploadedGalleryImagePaths.push(uploadResponse.data.imagePath);
                    } else {
                        console.error('Gallery image upload failed:', uploadResponse.data);
                        throw new Error('Gallery image upload failed: ' + JSON.stringify(uploadResponse.data));
                    }
                }
                dataToSend.new_images = uploadedGalleryImagePaths;
            } // Do not set dataToSend.new_images = [] if no new images; omit the field entirely

            dataToSend.features = JSON.stringify(features);
            console.log('Final data being sent:', dataToSend);

            const response = await axios.put('https://api.mitradingjp.com/update_car_ThirdParty.php', dataToSend, {
                headers: { 'Content-Type': 'application/json' },
            });
            console.log('Update response:', response.data);

            if (response.data.success) {
                alert(response.data.message);
                await fetchCarDetails();
                await fetchGalleryImages();
                navigate('/vehicles');
            } else {
                alert(response.data.message || response.data.error);
            }
        } catch (error) {
            console.error('Error updating car:', error);
            alert('An error occurred: ' + error.message);
        } finally {
            setIsUpdating(false); // Hide overlay
        }
    };

    const handleCancel = () => {
        navigate('/vehicles');
    };

    const featureList = [
        'abs', 'airbag', 'bluetooth', 'cdPlayer', 'dvd', 'tv', 'powerSteering', 'powerWindow',
        'sunRoof', 'leatherSeat', 'alloyWheels', 'ac', 'radio', 'cdChanger', 'powerSeat',
        'backTire', 'grillGuard', 'rearSpoiler', 'centralLock', 'jack', 'spareTire', 'wheelSpanner',
        'fogLights', 'backCamera', 'pushStart', 'keylessEntry', 'esc', 'cam360deg', 'bodyKit',
        'sideAirbag', 'powerMirror', 'sideSkirts', 'frontLip', 'navigation', 'turbo', 'powerDoor'
    ];

    return (
        <div className="admin-container">
            <div className="sidebar-container">
                {userType === "administrator" && <AdministratorSidebar />}
                {userType === "admin" && <AdminSidebar />}
                {userType === "user" && <UserSidebar />}
            </div>
            <div className="admin-content">
                <div className="adminnavbar">
                    <h1>Welcome to the Admin Panel, {userFullName}</h1>
                    <button onClick={logout} className="logoutbtn">Logout</button>
                </div>
                <div className="mainsection">
                    <h3>View All Vehicles</h3>
                </div>
                <div className="container mt-5">
                    <h1>Edit Vehicle</h1>
                    <form>
                        <div className="row edit-veh">
                            <div className="form-group col-md-2">
                                <label>Maker</label>
                                <input type="text" className="form-control" name="maker" value={formData.maker || ''} onChange={handleChange} />
                            </div>
                            <div className="form-group col-md-2">
                                <label>Model</label>
                                <input type="text" className="form-control" name="model" value={formData.model || ''} onChange={handleChange} />
                            </div>
                            <div className="form-group col-md-2">
                                <label>Year</label>
                                <input type="number" className="form-control" name="year" value={formData.year || ''} onChange={handleChange} />
                            </div>
                            <div className="form-group col-md-2">
                                <label>Website Price</label>
                                <input type="number" className="form-control" name="price" value={formData.price || ''} onChange={handleChange} />
                            </div>
                            <div className="form-group col-md-2">
                                <label>Country</label>
                                <input type="text" className="form-control" name="country" value={formData.country || ''} onChange={handleChange} />
                            </div>
                            <div className="form-group col-md-2">
                                <label>Mileage</label>
                                <input type="number" className="form-control" name="mileage" value={formData.mileage || ''} onChange={handleChange} />
                            </div>
                        </div>
                        <div className="row mt-3 edit-veh">                            
                            <div className="form-group col-md-2">
                                <label>Fuel</label>
                                <input type="text" className="form-control" name="fuel" value={formData.fuel || ''} onChange={handleChange} />
                            </div>
                            <div className="form-group col-md-2">
                                <label>Transmission</label>
                                <input type="text" className="form-control" name="transmission" value={formData.transmission || ''} onChange={handleChange} />
                            </div>
                            <div className="form-group col-md-2">
                                <label>Drive</label>
                                <input type="text" className="form-control" name="drive" value={formData.drive || ''} onChange={handleChange} />
                            </div>
                            <div className="form-group col-md-2">
                                <label>Color</label>
                                <input type="text" className="form-control" name="color" value={formData.color || ''} onChange={handleChange} />
                            </div>
                            <div className="form-group col-md-2">
                                <label>Stock ID</label>
                                <input readOnly type="text" className="form-control" name="stock_id" value={formData.stock_id || ''} onChange={handleChange} />
                            </div>
                            <div className="form-group col-md-2">
                                <label>Chassis #</label>
                                <input type="text" className="form-control" name="vin" value={formData.vin || ''} onChange={handleChange} />
                            </div>
                        </div>
                        <div className="row mt-3 edit-veh">
                            <div className="form-group col-md-2">
                                <label>Body Type</label>
                                <input type="text" className="form-control" name="body_type" value={formData.body_type || ''} onChange={handleChange} />
                            </div>
                            <div className="form-group col-md-2">
                                <label>Version</label>
                                <input type="text" className="form-control" name="version" value={formData.version || ''} onChange={handleChange} />
                            </div>
                            <div className="form-group col-md-2">
                                <label>Engine</label>
                                <input type="text" className="form-control" name="engine" value={formData.engine || ''} onChange={handleChange} />
                            </div>
                            <div className="form-group col-md-2">
                                <label>Location</label>
                                <input type="text" className="form-control" name="location" value={formData.location || ''} onChange={handleChange} />
                            </div>
                            <div className="form-group col-md-2">
                                <label>Steering</label>
                                <input type="text" className="form-control" name="steering" value={formData.steering || ''} onChange={handleChange} />
                            </div>
                            <div className="form-group col-md-2">
                                <label>Seats</label>
                                <input type="text" className="form-control" name="seats" value={formData.seats || ''} onChange={handleChange} />
                            </div>
                        </div>
                        <div className="row mt-3 edit-veh">                            
                            <div className="form-group col-md-2">
                                <label>Doors</label>
                                <input type="text" className="form-control" name="doors" value={formData.doors || ''} onChange={handleChange} />
                            </div>
                            <div className="form-group col-md-2">
                                <label>Dimension</label>
                                <input type="text" className="form-control" name="dimension" value={formData.dimension || ''} onChange={handleChange} />
                            </div>
                            <div className="form-group col-md-2">
                                <label>M3</label>
                                <input type="text" className="form-control" name="m3" value={formData.m3 || ''} onChange={handleChange} />
                            </div>
                            <div className="form-group col-md-2">
                                <label>Weight</label>
                                <input type="text" className="form-control" name="weight" value={formData.weight || ''} onChange={handleChange} />
                            </div>
                            <div className="form-group col-md-1">
                                <label>Sale %</label>
                                <input type="text" className="form-control" name="salePercent" value={formData.salePercent || ''} onChange={handleChange} />
                            </div>
                            <div className="form-group col-md-1">
                                <label>Int Rate</label>
                                <input type="text" className="form-control" name="interiorRating" value={formData.interiorRating || ''} onChange={handleChange} />
                            </div>
                            <div className="form-group col-md-1">
                                <label>Ext Rate</label>
                                <input type="text" className="form-control" name="exteriorRating" value={formData.exteriorRating || ''} onChange={handleChange} />
                            </div>
                        </div>
                        <div className="row mt-3">
                            <div className="form-group col-md-12">
                                <label>Features</label>
                                <div className="row edit-vehicle-features">
                                    {featureList.map((feature) => (
                                        <div key={feature} className="col-md-2 feature-item">
                                            <div className="form-check">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input"
                                                    id={feature}
                                                    name={feature}
                                                    checked={features[feature] || false}
                                                    onChange={handleFeatureChange}
                                                />
                                                <label className="form-check-label edit-vehicle-feature-label" htmlFor={feature}>
                                                    {feature}
                                                </label>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                        <div className="row mt-5">
                            <div className="form-group col-md-6">
                                <label>Main Image (car_details.images)</label>
                                <input type="file" className="form-control" name="images" onChange={handleMainImageChange} />
                                {car.images && (
                                    <div className="mt-2">
                                        <img
                                            src={`https://api.mitradingjp.com/${car.images}`}
                                            alt="Main Car Image"
                                            style={{ width: '70px', height: 'auto' }}
                                        />
                                    </div>
                                )}
                            </div>
                            <div className="form-group col-md-6">
                                <label>Gallery Images (car_images.image_path)</label>
                                <input type="file" className="form-control" name="gallery_images" onChange={handleGalleryImagesChange} multiple />
                                <div className="mt-2">
                                    {galleryImages.map((image, index) => (
                                        <img
                                            key={index}
                                            src={`https://api.mitradingjp.com/${image.image_path}`}
                                            alt={`Gallery Image ${index + 1}`}
                                            style={{ width: '70px', height: 'auto', marginRight: '10px' }}
                                        />
                                    ))}
                                </div>
                            </div>
                        </div>
                        <button type="button" className="btn btn-success" onClick={handleUpdate} disabled={isUpdating}>
                            Update
                        </button>
                        <button type="button" className="btn btn-danger ml-2" onClick={handleCancel}>Cancel</button>
                    </form>
                    {isUpdating && (
                        <div className="download-overlay">
                            <div className="download-text">Wait till updating the required vehicle</div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default EditVehiclesThirdParty;